// Places each header dropdown under its own menu item (see "simple dropdown" in eon-home.css).
// Uses delegation so it survives Horizon re-rendering the header.
(function () {
  function place(item) {
    var submenu = item.querySelector(':scope > .menu-list__submenu');
    if (!submenu || !submenu.offsetParent) return;
    var left = item.getBoundingClientRect().left - submenu.offsetParent.getBoundingClientRect().left;
    submenu.style.setProperty('--eon-dd-left', left + 'px');
  }
  function onEnter(event) {
    var item = event.target.closest && event.target.closest('.header-menu .menu-list__list-item');
    if (item) place(item);
  }
  document.addEventListener('pointerover', onEnter);
  document.addEventListener('focusin', onEnter);
})();
